import * as C from '../constants';
import * as I from '../interface';
import * as api from '../api';
import * as ActionCreators from './ActionCreators';
import { createAction } from 'redux-actions';

export const actionSetUserFavouriteTags = createAction(
  C.ACTION_TYPES.ENTITIES_SET_USER_FAVOURITE_TAGS,
  (user_favourite_tags: UserFavouriteTag[]) => ({ user_favourite_tags })
);

export const getUserFavouriteTags = (): I.ThunkAction => async (
  dispatch,
  getState
) => {
  const json = await api.entities.getUserFavouriteTags();
  dispatch(actionSetUserFavouriteTags(json.items));
};

export const postUserFavouriteTags = (
  tag_ids: number[]
): I.ThunkAction => async (dispatch, getState) => {
  const res = await api.entities.postUserFavouriteTags(tag_ids);
  if (res.ok) {
    // should be the same methods called in MyDataPageContainer.componentDidMount
    await dispatch(ActionCreators.fetchUserShopItemAll());
    await dispatch(ActionCreators.fetchFavouriteDataItems());
    await dispatch(ActionCreators.actionUpdateState(C.STATE.FAVOURITE.DEFAULT));
    await dispatch(ActionCreators.closeModal());
    window.location.reload();
  } else {
    await dispatch(
      ActionCreators.actionUpdateState(C.STATE.FAVOURITE.SERVER_ERROR)
    );
  }
};



// WEBPACK FOOTER //
// ./app/actions/entitiesActionCreators.ts